import script from "./FolderModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./FolderModal.vue?vue&type=script&setup=true&lang=ts"

import "./FolderModal.vue?vue&type=style&index=0&id=1a26f076&lang=scss"

const __exports__ = script;

export default __exports__